import { scrollToSection } from "@/components/site/Navbar";

const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-[#041a0f] border-t border-[#C5A880]/15">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <p className="font-display text-4xl lg:text-5xl text-[#F5F1E8] tracking-tight">
            Sage <span className="text-[#C5A880] italic">&</span> Spirit
          </p>
          <p className="mt-4 text-sm text-[#F5F1E8]/50 font-light max-w-md leading-relaxed">
            Ancient Wisdom, Modern Ritual. Luxury Ayurvedic herbal cigarettes —
            tobacco-free, nicotine-free, and crafted with reverence.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-[#C5A880] mb-5">Explore</p>
          <div className="flex flex-col gap-3">
            {[["Botanicals", "#botanicals"], ["Science", "#science"], ["Sourcing", "#sourcing"], ["Partners", "#partners"]].map(([label, href]) => (
              <button
                key={href}
                data-testid={`footer-link-${label.toLowerCase()}`}
                onClick={() => scrollToSection(href)}
                className="text-left text-sm text-[#F5F1E8]/60 hover:text-[#C5A880] transition-colors duration-300"
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-[#C5A880] mb-5">Partner Desk</p>
          <p className="text-sm text-[#F5F1E8]/60 font-light leading-relaxed">
            partners@sageandspirit.co<br />
            Mon–Fri · 9:00–18:00 IST
          </p>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#F5F1E8]/10">
        <p className="text-xs text-[#F5F1E8]/35 leading-relaxed max-w-3xl">
          For adults 21+. Sage & Spirit products contain no tobacco or nicotine. Herbal smoking
          products are not a safe alternative to smoking and are not intended to diagnose, treat,
          cure or prevent any disease. Inhaling any smoke carries risk.
        </p>
        <p className="mt-4 text-xs text-[#F5F1E8]/30">© 2026 Sage & Spirit Botanical Co. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
